// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateElSalvadorianPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  }
  const twentyDigitsRegex = /^\d{1,20}$/;
  if (!twentyDigitsRegex.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}
